(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }
}(function($) {

    // Defaults
    $.detectSwipe = {
        version: '2.1.2',
        enabled: 'ontouchstart' in document.documentElement,
        preventDefault: false,
        threshold: 30
    };

    var startX, startY,
        startClickX, startClickY
        isMoving = false;
        isMouseMoving = false;

    // Touch Events
    function onTouchEnd() {
        this.removeEventListener('touchmove', onTouchMove);
        this.removeEventListener('touchend', onTouchEnd);
        isMoving = false;
    }

    function onTouchMove(e) {
        if ($.detectSwipe.preventDefault) {
            e.preventDefault();
        }
        if (isMoving) {
            var dir = false,
                x = e.touches[0].pageX,
                y = e.touches[0].pageY,
                deltaX = startX - x,
                deltaY = startY - y,
                ratio = window.devicePixelRatio || 1,
                absX = Math.abs(deltaX) * ratio,
                absY = Math.abs(deltaY) * ratio;
            if ((deltaX > 10 || deltaX < -10) && absX >= $.detectSwipe.threshold && absY < 20) {
                dir = deltaX > 0 ? 'left' : 'right';
            } else if ((deltaY > 10 || deltaY < -10) && absY >= $.detectSwipe.threshold && absX < 20) {
                dir = deltaY > 0 ? 'up' : 'down';
            }
            if (dir) {
                onTouchEnd.call(this);
                if (dir == 'left' || dir == 'right') {
                    $(this).trigger('swipe', dir).trigger('swipe' + dir);
                }
            }
        }
    }

    function onTouchStart(e) {
        if (e.touches.length == 1) {

            // Disable swipe on photo carousels with more than one item
            if ($(e.target).parents().eq(3).hasClass('eedition-carousel') && $(e.target).parents().eq(2).children().length > 1) {
                return false;
            }
            startX = e.touches[0].pageX;
            startY = e.touches[0].pageY;
            isMoving = true;
            this.addEventListener('touchmove', onTouchMove, false);
            this.addEventListener('touchend', onTouchEnd, false);
        }
    }

    // Mouse Events
    function onMouseUp() {
        this.removeEventListener('mousemove', onMouseMove);
        this.removeEventListener('mouseup', onMouseUp);
        isMouseMoving = false;
    }

    function onMouseMove(e) {
        if ($.detectSwipe.preventDefault) {
            e.preventDefault();
        }
        if (isMouseMoving) {
            var dir = false,
                x = e.screenX,
                y = e.screenY,
                deltaX = startClickX - x,
                deltaY = startClickY - y,
                ratio = window.devicePixelRatio || 1,
                absX = Math.abs(deltaX) * ratio,
                absY = Math.abs(deltaY) * ratio;
            if ((deltaX > 10 || deltaX < -10) && absX >= $.detectSwipe.threshold && absY < 20) {
                dir = deltaX > 0 ? 'left' : 'right';
            } else if ((deltaY > 10 || deltaY < -10) && absY >= $.detectSwipe.threshold && absX < 20) {
                dir = deltaY > 0 ? 'up' : 'down';
            }
            if (dir) {
                onMouseUp.call(this);
                if (dir == 'left' || dir == 'right') {
                    $(this).trigger('swipe', dir).trigger('swipe' + dir);
                }
            }
        }
    }

    function onMouseStart(e) {
        startClickX = e.screenX;
        startClickY = e.screenY;
        isMouseMoving = true;
        this.addEventListener('mousemove', onMouseMove, false);
        this.addEventListener('mouseup', onMouseUp, false);
    }

    // Utilities
    function setup() {
        this.addEventListener && this.addEventListener('touchstart', onTouchStart, false);
        this.addEventListener('mousedown', onMouseStart, false);
    }

    $.event.special.swipe = { setup: setup };

    $.each(['left', 'up', 'down', 'right'], function () {
        $.event.special['swipe' + this] = { setup: function(){
          $(this).on('swipe', $.noop);
        }};
    });
}));